if (!customElements.get('slider-bonbons')) {
  class SliderBonbons extends customElements.get('slider-default') {
    constructor() {
      super();

      this.bonbonItems = this.querySelectorAll('[data-bonbon-item]');

      this.slider.on('transitionEnd', () => {
        const activeBonbonButton = this.querySelector(
          '[data-bonbon-button].is-active',
        );
        const activeSlide = activeBonbonButton.parentElement;

        if (activeSlide.classList.contains('swiper-slide-visible')) return;

        const activeBonbonItem = this.querySelector(
          '[data-bonbon-item].is-active',
        );
        const newActiveSlide = this.slider.slides[this.slider.realIndex];
        const newActiveBonbonButton = newActiveSlide.querySelector(
          '[data-bonbon-button]',
        );
        const newActiveBonbonItem = this.bonbonItems[this.slider.realIndex];

        activeBonbonButton.classList.remove('is-active');
        newActiveBonbonButton.classList.add('is-active');

        activeBonbonItem.classList.remove('is-active');
        newActiveBonbonItem.classList.add('is-active');
      });

      this.addEventListener('click', (e) => {
        const bonbonButton = e.target.closest('[data-bonbon-button]');

        if (!bonbonButton) return;

        const activeBonbonButton = this.querySelector(
          '[data-bonbon-button].is-active',
        );
        const activeBonbonItem = this.querySelector(
          '[data-bonbon-item].is-active',
        );
        const newActiveBonbonItem =
          this.bonbonItems[+bonbonButton.dataset.index];

        activeBonbonButton.classList.remove('is-active');
        bonbonButton.classList.add('is-active');

        activeBonbonItem.classList.remove('is-active');
        newActiveBonbonItem.classList.add('is-active');
      });
    }
  }

  customElements.define('slider-bonbons', SliderBonbons);
}
